package horcrux.frontend.common.views.documents

import horcrux.common.api.dtos.types.DocumentMetadata
import horcrux.frontend.common.BooleanState
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.State
import horcrux.frontend.common.views.components.containers.DialogAction
import horcrux.frontend.common.views.components.containers.DialogActionView
import horcrux.frontend.common.views.components.containers.DialogView
import mui.material.DialogTitle
import react.FC
import react.Props
import react.create

external interface DocumentExplorerDialogProps : Props {
    var documentMetadata: DocumentMetadata
    var documentMetadataListState: State<List<DocumentMetadata>>
    var globalAppState: GlobalAppState
}


val DocumentExplorerDialog = FC<DocumentExplorerDialogProps> { props ->
    val showDialogState = BooleanState()

    DocumentIcon {
        this.label = props.documentMetadata.documentName.betterToString()
        this.documentMetadata = props.documentMetadata
        this.showDialogState = showDialogState
    }

    val documentNavigatorMenuView = EditDocumentMenu.create {
        this.documentMetadata = props.documentMetadata
        this.documentMetadataListState = props.documentMetadataListState
        this.globalAppState = props.globalAppState
    }

    DialogView {
        this.showDialogState = showDialogState
        this.dialogActionsMaybe = listOf(
            DialogActionView(documentNavigatorMenuView) {},
            DialogAction("OK") { _, _ -> showDialogState.setFalse() })
        DialogTitle { +props.documentMetadata.documentName.betterToString() }
        props.globalAppState.getChildDocumentIDs(props.documentMetadata.documentID)?.let { childDocumentIDs ->
            DocumentNavigator {
                this.documentMetadataListState = props.globalAppState.documentMetadataListState
                this.documentMetadataFilter = { childDocumentIDs.contains(it.documentID) }
                this.globalAppState = props.globalAppState
            }
        } ?: run {
            DocumentBody {
                this.documentMetadata = props.documentMetadata
                this.globalAppState = props.globalAppState
            }
        }
    }
}
